
/* globals $, noUiSlider, FastClick, define */
/* jshint unused:false */

FastClick.attach(document.body);

var apiContentURL,
    apiTrackURL,
    selectedEndpoint,
    bDebug,
    endPoint,
    latestQuestionData,
    aMultiContentTmp,
    resetCurrentStep,
    lastSliderID,
    aPostcards = [],
    aOrder,
    bInterventionCompleted = false,
    oAnswers = {},
    oAnswersMaster = {},
    bNextClicked = false,
    alertInterval,
    credentialsCrossDomain = true;

(function (root, factory) {

  'use strict';

  if (typeof define === 'function' && define.amd) {
    define(function() {
      return factory(root);
    });
  } else if (typeof exports === 'object') {
    module.exports = factory;
  } else {
    root.Ripple = factory(root);
  }
})(this, function (root) {

  'use strict';

  var Ripple = {

    nextPage      : "",
    qData         : null,
    currentStep   : 0,

    init : function () {

      apiContentURL = siteURL + '/lvl3/lvl3/js/pcontent/',
      apiTrackURL = siteURL + '/lvl3/lvl3/js',
      selectedEndpoint = 0,
      bDebug = false,
      endPoint = aEndPointMap[selectedEndpoint],
      latestQuestionData,
      aMultiContentTmp = ['truefalse','likert'];

      if(bDebug) {
        apiContentURL = 'http://localhost:3000/data/'
      }

      var _self = this;

      // Question Pages
      this.initQuestTreeBtn();
      this.initCheckboxBtn();
      this.initTrueFalseBtn();
      this.initLikert();
      this.initTextInput();
      this.initNumberStepper();
      this.initGoalLikert();

      // Generic Page Functions

      this.setupFAQ();
      this.initSiteMenu();
      this.setupNextBtn();
      this.setupRegisterBtn();
      this.setupPostcard();
      this.setupVids();
      this.shareDialogs();
      this.setupAlerts();

      // Back Button
      this.handlePushState();

      this.preloadImages([
        '/wp-content/themes/ripple/dist/images/share-postcard-small.png',
        '/wp-content/themes/ripple/dist/images/share-postcard.png',
      ]);


      // If there is an existing LEAD, then get their data
      // and load saved progress
      if(window.oUser && !bDebug) {

        $('.lbl-loading').html('Loading saved progress');

        $.ajax({
          method: "GET",
          url: '?a=lvl3-get-lead&lead=' + oUser.id,
          success: function (data) {

            var data = JSON.parse(data).data;

            oUser.data = data;

            var coreData = data.fields.core;
            var chapterNumber = parseInt(coreData.intervention_progress_cha.value);
            var chapterStep = parseInt(coreData.intervention_progress_cha1.value) + 1;
            var aPostcards = coreData.postcards.value;

            // Updates selectedEndpoint with user progress
            selectedEndpoint = Ripple.getSelectedEndpoint(chapterNumber, chapterStep);
            endPoint = aEndPointMap[selectedEndpoint];

            Ripple.setAnswer(aPostcards, 'postcards');


            _self.getFirstContent();

          },
          xhrFields: {
              withCredentials: credentialsCrossDomain
          },
          crossDomain: credentialsCrossDomain
        });

      } else {
        this.getFirstContent();
      }

      $(document).on('keydown', '.number-input', function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
             // Allow: Ctrl+A, Command+A
            (e.keyCode == 65 && ( e.ctrlKey === true || e.metaKey === true ) ) ||
             // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
                 // let it happen, don't do anything
                 return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
      });


    },

    getQuestionContent : function (endPoint, cache, direction, callback) {

      Ripple.currentStep = 0;

      var _self = this;

      $.ajax({
        method: "GET",
        url: apiContentURL + endPoint,
        success: function (data) {

          if(data.result) {

            data.data[data.data.length - 1].output.bLast = true;

              if(cache) {
                Ripple.qDataCache = data.data;
              } else {
                Ripple.qData = data.data;
              }

              callback();
          } else {

            if(direction == 'forward') {
              selectedEndpoint++;
            } else {
              selectedEndpoint--;
            }

            var endPoint = aEndPointMap[selectedEndpoint];

            _self.getQuestionContent(endPoint.url, cache, direction, callback)
          }

        },
        xhrFields: {
            withCredentials: credentialsCrossDomain
        },
        crossDomain: credentialsCrossDomain
      });
    },

    getFirstContent : function () {

      var _self = this;

      if(!endPoint) {
        window.location = '/dashboard';
        return false;
      }

      this.getQuestionContent(endPoint.url, false, 'forward', function() {

        return _self.loadNewContent(true);
      });

    },

    preloadImages : function (array) {
      if (!this.preloadImages.list) {
          this.preloadImages.list = [];
      }
      var list = this.preloadImages.list;
      for (var i = 0; i < array.length; i++) {
          var img = new Image();
          img.onload = function() {
              var index = list.indexOf(this);
              if (index !== -1) {
                  // remove image from the array once it's loaded
                  // for memory consumption reasons
                  list.splice(index, 1);
              }
          }
          list.push(img);
          img.src = array[i];
      }
    },

    setupVids : function () {

      $(".content__body").fitVids();
      $(".postcard-wrap").fitVids();
    },

    setupResourcesLink : function () {

      $(document).on('click', '.link-resources', function (e) {
        e.preventDefault();

        $('.resource__overlay').addClass('show');
        $('.site-menu').removeClass('show');
      });

      $(document).on('click', '.rm__btn', function (e) {
        e.preventDefault();
        $('.resource__overlay').removeClass('show');

        $.ajax({
          method: 'POST',
          url: apiTrackURL,
          data: {
            requested_additional_reso: 1
          },
          success: function (data) {
            window.lvl3ID = data.id;
          },
          xhrFields: {
            withCredentials: credentialsCrossDomain
          },
          crossDomain: credentialsCrossDomain
        });
      });
    },

    setupAlerts : function () {
      $(document).on('click','.alert-close',function (e) {
        e.preventDefault();

        $('.alert').removeClass('show');
      });
    },

    shareDialogs : function () {

      $(document).on('click', '.send-dialog', function(e) {

        e.preventDefault();

        FB.ui({
          method: 'send',
          link: 'https://www.therippleeffect.com.au' //REPLACE THIS WITH A VALID URL FROM YOUR SITE OR USE PHP TO POPULATE IT
        }, function(response) {
        });
      });

      $(document).on('click', '.share-dialog', function(e) {

        e.preventDefault();

        FB.ui({
          method: 'share',
          href: 'https://www.therippleeffect.com.au' //REPLACE THIS WITH A VALID URL FROM YOUR SITE OR USE PHP TO POPULATE IT
        }, function(response) {
        });
      });
    },

    handlePushState : function () {

      var _self = this;


      history.pushState(null, null, '?active');

      window.addEventListener('popstate', function () {



        history.pushState(null, null, '?active');

        if(bInterventionCompleted) {

          Ripple.showAlert("You have completed the Ripple Effect. View your dashboard for next steps.")
          return false;
        }

        if(Number($('.ch-nbr').html()) == 1) {
          return false;
        }


        if(bNextClicked) {
          return false;
        }

        // Handle SOSS + LOSS
        if( Number($('.ch-nbr').html()) == (2 || 5)) {

          var bMulticontent = $('.paper-quest').first().data('multicontent');

          if(bMulticontent) {
            Ripple.sossGoBack();
          } else {
            var msg = "We can't get proper results for the Ripple Effect research if you go back at this point";
            Ripple.showAlert(msg);
          }

          return false;
        }

        if(Ripple.bEndOfStep() && Ripple.currentStep > 1) {
          selectedEndpoint--;
        }

        if(Ripple.currentStep > 1) {

          if($('.paper-quest').first().data('multicontent')) {
            Ripple.currentStep = Ripple.currentStep - Ripple.qData[Ripple.currentStep-1].output.steps.length - 1;
          } else {
            Ripple.currentStep = Ripple.currentStep - 2;
          }

          _self.loadNewContent(true, 'left');

        } else {

          if(aEndPointMap[selectedEndpoint-1].chapterStep == 1) {
            var msg = '<strong>Sorry! You cannot revisit a previous chapter.</strong>'
            Ripple.showAlert(msg);
            return false;
          }


          if(selectedEndpoint > 1 && aEndPointMap[selectedEndpoint-1].chapterStep > 1) {

            selectedEndpoint -= 2;
            Ripple.loadNextStepThenScreen('backward');

            var msg = '<strong>Loading previous step ... </strong>'
            Ripple.showAlert(msg);
          }

        }

      });


    },

    setupPostcard : function () {

        $(document).on('click', '.text-post__overlay, .text-post__btn', function (e){
          e.preventDefault();
          $('.text-post').removeClass('show');
          $('.page-head').css('z-index', 9000);
          $('.page-actions').css('z-index', 1000);
        });

        $(document).on('click', '.postcard__link', function (e) {
          e.preventDefault();
          $(this).parent().find('.text-post').addClass('show');

          $('.page-head').css('z-index', 90);
          $('.page-actions').css('z-index', 0);
          $('.text-post__content').css('display', 'block');
        });

    },

    decodeApiString : function (text) {
      return $('<div/>').html(text).text()
    },

    getSelectedEndpoint : function (chapterNum, chapterStep) {

      for (var i = 0; i < aEndPointMap.length; i++) {

        if(chapterNum == aEndPointMap[i].chapterNum) {

          return i + chapterStep - 1;
        }


      }

    },

    sossGoBack : function () {

       if($('.paper-quest--card-done').length) {

        $('.paper-quest').first().find('.paper-quest--card3').removeClass('paper-quest--card3');

        $('.paper-quest').first().find('.paper-quest--card2').addClass('paper-quest--card3');
        $('.paper-quest').first().find('.paper-quest--card2').removeClass('paper-quest--card2');

        $('.paper-quest').first().find('.paper-quest--card1').addClass('paper-quest--card2');
        $('.paper-quest').first().find('.paper-quest--card1').removeClass('paper-quest--card1');

        $('.paper-quest').first().find('.paper-quest--card-done').first().addClass('paper-quest--card1');
        $('.paper-quest').first().find('.paper-quest--card-done').first().removeClass('paper-quest--card-done');


        // Likert buttons

        $('.likert--btn').removeClass('selected');
        $('.btn__likert').removeClass('active');
        $('.likert-group').removeClass('inactive');

        $('body').removeClass('question-completed');

       } else {

        var msg = "We can't get proper results for the Ripple Effect research if you go back at this point";
        Ripple.showAlert(msg);
       }
    },

    checkMultiContent : function () {

      var qData = Ripple.qData;
      var item = qData[Ripple.currentStep].output;

      var currentTemplate = item['question-template'][0];
      var isMulti = aMultiContentTmp.indexOf(currentTemplate);

      // If current item is multi content, then loop through
      // and build the steps

      if (isMulti >= 0) {

        var aSteps = [];

        var stepIndex = 0;

        var endOfStep = false;

        // If we reached the end of the step last time we ran this
        // then ensure we reset the current step. Fixes 2 multicontent steps in a row
        // Update: don't reset if current step is 1 otherwise it will break
        if(resetCurrentStep && Ripple.currentStep !== 1) {
          Ripple.currentStep = 0;

        }

        for (var i = Ripple.currentStep; i < qData.length; i++) {


          var stepItem = qData[i].output;
          var nextTemplate = stepItem['question-template'][0];

          if(currentTemplate === nextTemplate) {

            stepIndex++;

            var oStep = {
              description : Ripple.decodeApiString(Ripple.qData[i].output.description),
              leadField : Ripple.qData[i].output['question-lead-field1'].alias,
              stepIndex : stepIndex
            };

            aSteps.unshift(oStep);
            Ripple.qData[i].output.skip = true;
            Ripple.currentStep++;

          } else {
            Ripple.currentStep--;
            break;
          }
        }

        if(Ripple.bEndOfStep()) {
          resetCurrentStep = true;
        }

        // Fix to get the correct question if we are at the
        // end of the array. Not sure why this works exactly.
        if(Ripple.currentStep == Ripple.qData.length) {
          Ripple.currentStep--;
        }

        Ripple.qData[Ripple.currentStep].output.steps = aSteps;

      }

       resetCurrentStep = false;

    },

    setupFAQ : function () {

      $('.faq__link, .faq__icon').on('click', function (e) {

        e.preventDefault();

        $(this).closest('.faq__item').toggleClass('active');
      });

    },

    setupBg : function () {

      var bodyClass;

      switch (aEndPointMap[selectedEndpoint].chapterNum) {
          case 1:
              bodyClass = "body--ch1";
              break;
          case 2:
              bodyClass = "body--ch2";
              $('body').removeClass('body--ch1');
              break;
          case 3:
              bodyClass = "body--ch3";
              $('body').removeClass('body--ch2');
              break;
          case 4:
              bodyClass = "body--ch4";
              $('body').removeClass('body--ch3');
              break;
          case 5:
              bodyClass = "body--ch5";
              $('body').removeClass('body--ch4');
              break;
        }

      $('body').addClass(bodyClass);

    },
    initNumberStepper : function () {

      if($('#number-stepper').length) {

        var circularSlider = $('#number-stepper').CircularSlider({
          min : 10,
          max: 120,
          value : 20,
          handleDist : 120,
          radius: 238,
          slide : function(ui, value) {
            Ripple.setAnswer(value);


          }
        });

        Ripple.setAnswer(circularSlider.getValue(), $('.current-page').last().data('leadalias1'));

      }
    },


    setAnswer : function (value, alias) {

      if(Ripple.bHaveAnswer() || alias) {

        var alias1;

        if($('.current-page').first().data('leadalias1')) {
          alias1 = $('.current-page').first().data('leadalias1');
        }

        if(alias) {
          alias1 = alias;
        }

        if(value instanceof Array) {
          if(oAnswers[alias1 + '[]']) {

            // Only merge postcards, other multi-content just replace the array each time.
            if(alias1 == 'postcards') {
              var aMerge = oAnswers[alias1 + '[]'].concat(value);
              aMerge = Ripple.uniq(aMerge);
            } else {
              var aMerge = value;
            }

            oAnswers[alias1 + '[]'] = aMerge;
          } else {
            oAnswers[alias1 + '[]'] = value;
          }

        } else {

          value = value.toString();
          value = value.replace(/(\r\n|\n|\r)/gm,"");
          oAnswers[alias1] = value.trim();
        }

        console.log(oAnswers);
      }


    },

    uniq : function (a) {
      var seen = {};
      return a.filter(function(item) {
          return seen.hasOwnProperty(item) ? false : (seen[item] = true);
      });
    },

    initSiteMenu : function () {

      $('.top-nav__menu-btn').on('click', function (e){
        e.preventDefault();
        $('.site-menu').addClass('show');
      });

      $(document).on('click', '.site-menu__hide', function (e) {
        e.preventDefault();
        $('.site-menu').removeClass('show');
      });

       $('.top-nav__phone-btn').on('click', function (e){
        e.preventDefault();
        $('.phonecall').addClass('show');
      });

       $('.phonecall__overlay, .phonecall__btn').on('click', function (e){
        e.preventDefault();
        $('.phonecall').removeClass('show');
      });

      $(document).on('click', '.site-menu__hide', function (e) {
        e.preventDefault();
        $('.site-menu').removeClass('show');
      });

    },
    autoNext : function () {


      if($('.single-page.current-page').first().data('autonext')) {


        Ripple.activateNext();

      }


    },
    initQuestTreeBtn : function () {


      $(document).on('click', '.quest-tree--radio', function (e) {
        e.preventDefault();

        $('.quest-tree__btn').removeClass('selected');
        $(this).addClass('selected');

        var answer = $(this).text().trim();

        if($(this).data('type') == 'boolean') {

          if(answer.toLowerCase() == 'true' || answer.toLowerCase() == 'yes') {
            answer = '1';
          } else {
            answer = '0';
          }


        }

        Ripple.setAnswer(answer);

        Ripple.activateNext();
      });
    },

    initCheckboxBtn : function () {

      aOrder = [];

      $(document).on('click', '.quest-tree--check', function (e) {
        e.preventDefault();

        var answer = $(this).data('key');

        // Ordered Checkbox
        // for Farming Type
        if($(this).hasClass('ordered')) {

          if($(this).hasClass('selected')) {
            var index = aOrder.indexOf(answer); // remove from order array
            aOrder.splice(index, 1);
          } else {
            aOrder.push(answer);
          }

          $('.quest-tree--check.ordered span').html('');


          for (var i = 0; i < 3; i++) {

            var key = aOrder[i];
            var leadAlias = $('.current-page').first().data('leadalias' + (i+2));

            // Set number
            $("[data-key='" + key + "'] span").html(i+1);

            if(key) {
              Ripple.setAnswer(key, leadAlias);
            } else {
              delete oAnswers[leadAlias];
            }

          }

        }

        $(this).toggleClass('selected');

        var aSelected = [];
        $('.quest-tree--check.selected').each(function() {
           var answer = $(this).data('key');
          aSelected.push(answer);
        });

        Ripple.setAnswer(aSelected);
        Ripple.activateNext();
      });
    },
    initTrueFalseBtn : function () {

      $(document).on('click', '.true-false__btn, .btn__likert', function (e) {
        e.preventDefault();

        var leadAlias = $('.paper-quest--card1').first().data('leadalias');

        var leadValue;


        if($(this).data('leadvalue')) {
          leadValue = $(this).data('leadvalue'); //TRue False

          if(leadValue.toLowerCase() == 'true' || leadValue.toLowerCase() == 'yes') {
            leadValue = '1';
          } else {
            leadValue = '0';
          }

        } else {

          leadValue = $('.likert--btn.selected').first().data('value');

          $(this).removeClass('active');
          $('.likert--btn').removeClass('selected');
        }

        Ripple.setAnswer(leadValue, leadAlias);


        $('.true-false__btn').removeClass('selected');
        $(this).addClass('selected');

        if($('.paper-quest').first().find('.paper-quest--card2').length) {
          $('.paper-quest').first().find('.paper-quest--card3').prev().addClass('paper-quest--card3');
          $('.paper-quest').first().find('.paper-quest--card3').last().removeClass('paper-quest--card3');
          $('.paper-quest').first().find('.paper-quest--card2').prev().addClass('paper-quest--card2');
          $('.paper-quest').first().find('.paper-quest--card2').last().removeClass('paper-quest--card2');
          $('.paper-quest').first().find('.paper-quest--card1').prev().addClass('paper-quest--card1');
          $('.paper-quest').first().find('.paper-quest--card1').last().addClass('paper-quest--card-done');
          $('.paper-quest').first().find('.paper-quest--card1').last().removeClass('paper-quest--card1');

          $('body').removeClass('question-completed');
        } else {

          $('.likert-group').addClass('inactive');
          $('body').addClass('question-completed');
          Ripple.activateNext();
        }
      });
    },

    initGoalLikert : function () {

        var slider = document.getElementById('likert-goal');

        var aLabels = ['1 day', '', '', '', '14 days'];

        var pageAlias = $('.current-page').last().data('leadalias1');


        if(slider) {

          noUiSlider.create(slider, {
            start: [5],
            step: 1,
            pips: {
              mode: 'positions',
              values: [1,100]
            },
            range: {
              'min': 1,
              'max': 14
            }
          });

          $('#likert-goal').prepend('<div class=\'likert-click-fix\'></div>');
          $('#likert-goal').append('<div class=\'likert-labels\'></div>');

          $('.noUi-handle').append('<div class=\'likert-value\'></div>');

          $('.likert-click-fix').on('click', function (e) {

            e.preventDefault();
            slider.noUiSlider.set(1);

          });

          for (var i=0; i < aLabels.length; i++) {
            $('.likert-labels').append('<div class="likert__label likert--label' + (i + 1) + '">' + aLabels[i] + '</div>');
          }

          var _self = this;


          var alias = $('.current-page').last().data('leadalias1');

          if(oAnswers[alias]) {
            slider.noUiSlider.set(oAnswers[alias]);
          }

          Ripple.setAnswer(Number(slider.noUiSlider.get()),$('.current-page').last().data('leadalias1'));


          function setGoalDate () {

            var sliderDays = parseInt(slider.noUiSlider.get());

            var someDate = new Date();
            var numberOfDaysToAdd = sliderDays;
            someDate.setDate(someDate.getDate() + numberOfDaysToAdd);

            var dd = ("0" + someDate.getDate()).slice(-2);
            var mm = ("0" + (someDate.getMonth() + 1)).slice(-2)
            var y = someDate.getFullYear();

            var someFormattedDate = y + '/'+ mm + '/'+ dd;


            var dateAlias = pageAlias.substring(0, pageAlias.length - 1) + 'date';


            Ripple.setAnswer(someFormattedDate, dateAlias);


          }


          slider.noUiSlider.on('update', function(values, handle){

            var sValue = Number(values[0]).toString() + ' days';

            if(Number(values[0]) == 1) {
              sValue = '1 day';
            }

            $('.likert-value').html(sValue);
            $('.g-msg-end strong').html(sValue);

            setGoalDate();

          });

        }
    },


    initLikert : function () {


      $(document).on('click', '.likert--btn', function (e) {
        e.preventDefault();

        $('.likert--btn').removeClass('selected');

        $(this).addClass('selected');

        $('.btn__likert').addClass('active');
      })


        // var sliderID = 'likert-slider' + $('.l-slider').last().data('id');

        // var slider = document.getElementById(sliderID);


        // var aLabels = ['Strongly<br>disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly<br>Agree'];

        // if(slider) {


        //   noUiSlider.create(slider, {
        //     start: [1],
        //     step: 1,
        //     pips: {
        //       mode: 'positions',
        //       values: [0,25,50,75,100],
        //       density: 100
        //     },
        //     range: {
        //       'min': 1,
        //       'max': 5
        //     }
        //   });

        //   $('#'+ sliderID).prepend('<div class=\'likert-click-fix\'></div>');
        //   $('#'+ sliderID).append('<div class=\'likert-labels\'></div>');

        //   $('.likert-click-fix').on('click', function (e) {

        //     e.preventDefault();
        //     slider.noUiSlider.set(1);

        //   });

        //   for (var i=0; i < aLabels.length; i++) {
        //     $('.likert-labels').append('<div class="likert__label likert--label' + (i + 1) + '">' + aLabels[i] + '</div>');
        //   }

        //   this.updateSlider(slider);

        //   var _self = this;

        //   slider.noUiSlider.on('update', function(){
        //     _self.updateSlider(slider);
        //   });

        //   slider.noUiSlider.on('change', function(){

        //   });

        // }
    },

    updateSlider: function (theSlider) {

      var value = parseInt(theSlider.noUiSlider.get());

      $('.likert__label').removeClass('selected');
      $('.likert--label' + value).addClass('selected');

    },

    initTextInput : function () {
      $(document).on('change', '.text-answer', function (e) {
        e.preventDefault();
        Ripple.activateNext();
      });

      $(document).on('input', '.text-answer', function (e) {
        e.preventDefault();

        var nInput = $(this).val().length;
        var nMaxLength = $(this).attr('maxlength');

        if(nInput === parseInt(nMaxLength)) {

          Ripple.setAnswer($(this).val());
          Ripple.activateNext();
        }

        // Not postcode, so just activate on keypress
        if(nInput > 0 && (parseInt(nMaxLength) < 4)) {
          Ripple.setAnswer($(this).val());
          Ripple.activateNext();
        }

      });


    },

    activateNext : function () {

      var bInlineNext = $('.single-page .btn__next--inline').length;

      //if(!bInlineNext) {
        $('.page-actions').first().addClass('activated');
      //}


      var endPoint = aEndPointMap[selectedEndpoint];

      if(endPoint && !Ripple.bEndOfStep()) {

        this.loadNewContent();
      }
    },

    bEndOfStep : function () {
      if(Ripple.currentStep >= Ripple.qData.length) {
        return true;
      } else {
        return false;
      }
    },

    loadNewContent : function (bInline, direction) {


      if(this.bEndOfStep()) {
        //return false;
      }

      this.checkMultiContent();

      var _self = this;

      // The current question
      var oQuestion = jQuery.extend(true, {}, Ripple.qData[Ripple.currentStep].output);

      var mustacheTemplate = oQuestion['question-template'][0];

      if(typeof mustacheTemplate === 'string') {
        mustacheTemplate = oQuestion['question-template'] // See if it's text (chapter 4)
      }


      var template = $('#' + mustacheTemplate).html();

      // Question Answer List
      var aQuestions;

      var qType = '';

      // Piped List (Select)
      if(oQuestion["question-lead-field1"] && oQuestion["question-lead-field1"].properties && (oQuestion["question-lead-field1"].type == 'select' || oQuestion["question-lead-field1"].type == 'multiselect')) {
        aQuestions = Ripple.decodeApiString(oQuestion["question-lead-field1"].properties.list);
        aQuestions = aQuestions.split( "|" );

        qType = 'select';

      }

      // Boolean List (Boolean)

      if(oQuestion["question-lead-field1"] && oQuestion["question-lead-field1"].properties && oQuestion["question-lead-field1"].type == 'boolean') {

        qType = 'boolean';
        aQuestions = $.map(oQuestion["question-lead-field1"].properties, function(value, index) {
            return [value];
        });
      }

      oQuestion.type = function () {
        return qType;
      }


      oQuestion['question-answers'] = function () {
        return aQuestions;
      }

      oQuestion.nQuestions = function () {

        var sEven = '';

        if(aQuestions.length % 2 == 0)
        {
          sEven += ' quest--even';
        }

        if(aQuestions.length < 8) {
          sEven += ' items-few'
        }

        return 'items-' + aQuestions.length + sEven;
      }

      var qDescription = oQuestion.description;

      oQuestion.description = function () {

        var decodedText = Ripple.decodeApiString(qDescription);
        return decodedText;
      };

      var qTranscript = oQuestion['video-transcript'];

      oQuestion['video-transcript'] = function () {

        var decodedText = Ripple.decodeApiString(qTranscript);
        return decodedText;
      };

      if(!qTranscript || qTranscript.trim().length < 10) {

        oQuestion.showlink = function () {
          return 'hidelink';
        }

      } else {
        oQuestion.showlink = function () {
          return 'showlink';
        }
      }

      var qTitle = oQuestion.title;


      oQuestion.customImage = function () {

        if(this.template_image_filename) {

          var s = this.template_image_filename;
          s = s.replace(/ /g, '_');
          s = s.replace('/', 's');
          s = s.toLowerCase();
          return s;
        }


      }

      oQuestion.title = function () {

        var decodedText = Ripple.decodeApiString(qTitle);

        return decodedText;
      };

      oQuestion.id = function () {
        return selectedEndpoint + '-' + Ripple.currentStep;
      };

       oQuestion.chapterNumber = function () {
        return aEndPointMap[selectedEndpoint].chapterNum;
      };

      oQuestion.sizeClass = function () {
        return (oQuestion['question-answers'].length < 7 ? "--small" : "");
      };


      oQuestion.isLast = function () {
        return (oQuestion.bLast ? "true" : "false");
      };

      oQuestion.stepLength = function () {
        if(oQuestion.steps) {
          return oQuestion.steps.length;
        } else {
          return 0;
        }
      };

      var rendered = Mustache.render(template, oQuestion);

      $('.single-page.next-page').html(rendered);





      if(bInline) {
        _self.goNextScreen(direction);
      }

    },

    goNextScreen : function (direction) {

      var directionClass = 'pt-page-moveFromRight';

      if(direction) {
        directionClass = 'pt-page-moveFromLeft';
      }

      //Track previous step
      if(selectedEndpoint > 0) {

        var chNum = aEndPointMap[selectedEndpoint].chapterNum;
        var chStep = aEndPointMap[selectedEndpoint].chapterStep - 1;
        var pURL = aEndPointMap[selectedEndpoint - 1].url;

        $.ajax({
          method: 'POST',
          url: apiTrackURL,
          data: {
            url: '/' + pURL + '/completed',
            intervention_progress_cha: chNum,
            intervention_progress_cha1: chStep
          },
          success: function (data) {
            window.lvl3ID = data.id;

            syncLvl3ID(window.lvl3ID);
          },
          xhrFields: {
            withCredentials: credentialsCrossDomain
          },
            crossDomain: credentialsCrossDomain
          });
      }


      Ripple.currentStep++;

       $('body').addClass("transitioning");

        // Remove previous page from DOM
        var currentPage = $('.single-page').first().addClass('pt-page-fade');

        // Unwrap loaded page to reset DOM with new content
        var nextPage = $('.single-page.current-page').last().unwrap();
        nextPage.addClass(directionClass);

        $('.chapter__number').html('Chapter <span class="ch-nbr">1</span> of 5:  <span class="chapter__title"></span>');


        // Update Chapter Heading
        var chapterNumber = aEndPointMap[selectedEndpoint].chapterNum;
        var chapterTitle;

        $('.ch-nbr').html(chapterNumber);
        $('.chapter__title').html(qMap[chapterNumber-1].title);




        this.setupBg();

        var saveSelectedEndpoint = selectedEndpoint;

        var _self = this;
        nextPage.on('webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend', function (e) {
          $('body').removeClass("transitioning");
          currentPage.remove();
          nextPage.removeClass(directionClass);
          _self.autoNext();

          bNextClicked = false;
          $('textarea').focus();

          // Update Chapter Progress

          var chapPercent = Math.round(aEndPointMap[saveSelectedEndpoint].chapterStep / qMap[aEndPointMap[saveSelectedEndpoint].chapterNum - 1].steps.length * 100);
          var sPercent = chapPercent.toString() + '%';

          $('.progress-section').css('display', 'block');
          $('.ch-percentage').html( sPercent);
          $('.progress-bar__inner').css('width',sPercent);

        });


        // Load textarea previous answer, if it's been answered this session
        // e.g if user goes back to goal textarea

        if($('textarea').last().data('leadanswer1') && $('.current-page').last().data('leadalias1')) {

          var alias = $('.current-page').last().data('leadalias1');

          if(oAnswers[alias]) {
            $('.single-page.current-page').last().find('textarea').html(oAnswers[alias]);
          }


        }

        this.bEndOfStep();

        if(this.bEndOfStep()) {

          selectedEndpoint++;

          var endPoint = aEndPointMap[selectedEndpoint];

          if(!endPoint) {
            //console.log("THE END!");

            bInterventionCompleted = true;


            var chNum = aEndPointMap[selectedEndpoint-1].chapterNum;
            var chStep = aEndPointMap[selectedEndpoint-1].chapterStep;
            var pURL = aEndPointMap[selectedEndpoint - 1].url;




            ga('send', 'event', 'Intervention Completed', 'Completed', 'User ID: ' + window.lvl3ID);

            $.ajax({
              method: 'POST',
              url: apiTrackURL,
              data: {
                intervention_completed: 1,
                url: '/' + pURL + '/completed',
                intervention_progress_cha: chNum,
                intervention_progress_cha1: chStep
              },
              success: function (data) {
                window.lvl3ID = data.id;

                syncLvl3ID(window.lvl3ID);
              },
              xhrFields: {
                withCredentials: credentialsCrossDomain
              },
              crossDomain: credentialsCrossDomain
            });
          }

        }

        // Init components again?
        this.initLikert();
        this.initNumberStepper();
        this.initGoalLikert();
        this.setupVids();

        // Reset ordered checkbox array
        aOrder = [];





    },

    setupNextBtn : function () {

      var _self = this;

      $(document).on('click', '.btn__next', function(e) {

        if(!bNextClicked) {

          bNextClicked = true;
          e.preventDefault();
          $(this).addClass('loading');


          // Check if postcard

          if($('.current-page').first().find('[data-postcard]').length) {
            aPostcards.push($('.current-page').first().find('[data-postcard]').data('postcard'));
            Ripple.setAnswer(aPostcards, 'postcards');
          }


          // Get answers from textareas
          if($('textarea').length > 0) {
            Ripple.getAnswersFromPage();
          }


          _self.postAnswer(false);

        }



      });

      //Inline Next

      $(document).on('click', '.btn__next--inline:not(.btn--register)', function (e) {


        if($(this).hasClass('btn-consent')) {
          if(!Ripple.validateConsent()) {
            return false;
          };
        }


        if(!bNextClicked) {

          bNextClicked = true;
          e.preventDefault();
          $(this).addClass('loading');

          var endPoint = aEndPointMap[selectedEndpoint];

          if(endPoint && !Ripple.bEndOfStep()) {
            Ripple.getAnswersFromPage();
            _self.loadNewContent(true);
          } else {
            Ripple.getAnswersFromPage();
            _self.postAnswer(true);
          }
        }
      });
    },

    validateConsent : function () {

      if(!$('input[name="firstname"]').val()) {
        var msg = "You must enter your first name";
        Ripple.showAlert(msg);
        return false;

      }

      if(!$('input[name="lastname"]').val()) {
        var msg = "You must enter your last name";
        Ripple.showAlert(msg);
        return false;
      }

      // if(!$('input[name="mobile"]').val()) {
      //   var msg = "You must your phone number";
      //   Ripple.showAlert(msg);
      //   return false;
      // }

      return true;
    },

    validateEmail : function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    setupRegisterBtn : function () {

      $(document).on('click', '.btn--register', function(e) {

        e.preventDefault();


        if(!Ripple.validateConsent()) {
          return false;
        };

        // Validate Registration Form
        if(!Ripple.validateEmail($('.email_register').val())) {
          var msg = "Invalid email address.";
          Ripple.showAlert(msg);
          return false;
        }

        var pwd = $('.pass_register').val();
        var pwdconfirm = $('.passconfirm_register').val();

        if(pwd.length == 0) {
          var msg = "Password cannot be blank.";
          Ripple.showAlert(msg);
          return false;
        }

        if(pwd !== pwdconfirm) {
          var msg = "Password does not match the confirm password.";
          Ripple.showAlert(msg);
          return false;
        }

        $(this).addClass('loading');

        var _self = this;

        var data = {
          action   : 'register_user',
          security : MyAjax.security,
          email : $('.email_register').val(),
          password : $('.pass_register').val(),
          lvl3DID : window.lvl3ID
        };

        $.post(MyAjax.ajaxurl, data, function(response) {

          var data = JSON.parse(response);

          if(data.result === true) {

            // Go to Next Screen as per any other
            // inline button
            var endPoint = aEndPointMap[selectedEndpoint];

            if(endPoint && !Ripple.bEndOfStep()) {
              Ripple.getAnswersFromPage();
              Ripple.loadNewContent(true);
            } else {
              Ripple.getAnswersFromPage();
              Ripple.postAnswer(true);
            }


          } else {

            var msg = "<strong>" + $('.email_register').val() + "</strong> has already registered.";

            Ripple.showAlert(msg);

            $(_self).removeClass('loading');
          }

        });

      });

    },

    showAlert : function (msg) {
      $('.alert-msg').html(msg);
      $('.alert').addClass('show');

      clearTimeout(alertInterval);
      alertInterval = setTimeout(function () {

        $('.alert').removeClass('show');

      }, 3000);
    },

    getAnswersFromPage : function () {


      for (var i = 1; i < 5; i++) {

        if($('.current-page').first().data('leadalias' + i) && $('.current-page').first().data('leadalias' + 1).length > 0 ) {

          var leadAlias = $('.current-page').first().data('leadalias' + i);
          var leadValue = $('.current-page').first().find('[data-leadanswer'+i+']').val();

          if(!leadValue || !leadAlias) {
            break;
          }

          Ripple.setAnswer(leadValue, leadAlias);
        }
      }



    },
    bHaveAnswer : function () {


      if(!$('.current-page').first().data('leadalias1') || $('.current-page').first().data('leadalias1').length == 0 ) {
        return false;
      } else {
        return true;
      }

    },

    postAnswer : function (inline) {

      $(this).addClass('loading');


      var _self = this;

      // If not last page just load next screen in step
      if($('.current-page').first().data('blast') == false) {

        if(!this.bEndOfStep()) {
          this.goNextScreen(inline);

          // Send the answer asynchronously whenever someone clicks next
          $.ajax({
            method: "POST",
            url: apiTrackURL,
            data: oAnswers,
            success: function (data) {
              window.lvl3ID = data.id;
              syncLvl3ID(window.lvl3ID);
            },
            xhrFields: {
                withCredentials: credentialsCrossDomain
            },
            crossDomain: credentialsCrossDomain
          });

        }
      } else {

        var chNum = aEndPointMap[selectedEndpoint].chapterNum;
          var chStep = aEndPointMap[selectedEndpoint].chapterStep - 1;

          ga('send', 'event', 'Chapter ' + chNum + ' - Step ' + chStep, 'Completed', 'User ID: ' + window.lvl3ID);


        if(Ripple.bHaveAnswer() || Ripple.currentStep > 1 || $('.current-page').first().find('[data-postcard]').length) {

          // Send the answer and wait for lvl3 personalisations
          // at the end of the step
          $.ajax({
            method: "POST",
            url: apiTrackURL,
            data: oAnswers,
            success: function (data) {
              window.lvl3ID = data.id;
              syncLvl3ID(window.lvl3ID);
              _self.loadNextStepThenScreen();
            },
            xhrFields: {
                withCredentials: credentialsCrossDomain
            },
            crossDomain: credentialsCrossDomain
          });

        } else {
          this.loadNextStepThenScreen ();
        }
      }

      $.extend( oAnswersMaster, oAnswers );
      oAnswers = {};
    },

    loadNextStepThenScreen : function (direction) {
      var endPoint = aEndPointMap[selectedEndpoint];
      var _self = this;

      var direction = direction || 'forward';


      _self.getQuestionContent(endPoint.url, true, direction, function() {

        Ripple.qData = Ripple.qDataCache;
        return _self.loadNewContent(true);
      });
    }

  };

  return Ripple;

});




